/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1TransferState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_TRANSFER_STATE_ENTITY_NAME = 'ixc.funding.v1.Transfer';
export const ixcFundingV1TransferStateEntity = new schema.Entity<IxcFundingV1TransferState>(IXC_FUNDING_V1_TRANSFER_STATE_ENTITY_NAME, {}, { idAttribute: 'transferId' });

